import { ERRORS_MESSAGE } from "@lhd/constants";
import { UNIT_OF_MEASURE_TYPE } from "@lhd/features/Apps/AppForm/constants";
import { Checkbox, Form, FormInstance, Input, InputNumber, Space } from "antd";
import { FC } from "react";
import { StyledDecimalPlaceInputItem, StylesRadioItem } from "./styled";

type PropsType = {
  form: FormInstance;
  getFieldClassName?: (name: string) => string;
};

const NumberSetting: FC<PropsType> = ({ form, getFieldClassName }) => {
  const min = Form.useWatch("min_num_char", form) || -Infinity;
  const max = Form.useWatch("max_num_char", form) || Infinity;
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_use_thousands_separators"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>桁区切り記号を利用する</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_prohibit_duplicate_values"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>重複値を禁止する</Checkbox>
      </Form.Item>
      <div className="number-chars-section">
        <div>価値の限界</div>
        <Space direction="horizontal">
          <Form.Item
            name="min_num_char"
            label={<p style={{ fontSize: 12 }}>最小</p>}
          >
            <InputNumber precision={0} min={1} />
          </Form.Item>
          <Form.Item
            name="max_num_char"
            label={<p style={{ fontSize: 12 }}>最大</p>}
          >
            <InputNumber precision={0} min={1} />
          </Form.Item>
        </Space>
      </div>
      <Form.Item
        name="default_value"
        label="初期値"
        rules={[{ min, max, type: "number" }]}
      >
        <InputNumber />
      </Form.Item>
      <StyledDecimalPlaceInputItem>
        <Form.Item
          name="number_of_decimal_place"
          label="表示する小数点以下の桁数"
        >
          <InputNumber
            min={0}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </Form.Item>
      </StyledDecimalPlaceInputItem>
      <div className="d-flex">
        <Form.Item name="unit_of_measure" label="測定単位">
          <Input className="align-right" />
        </Form.Item>
        <StylesRadioItem>
          <Form.Item
            label=""
            name="unit_of_measure_type"
            className="radio-item"
            initialValue={UNIT_OF_MEASURE_TYPE.suffix}
          >
            <Checkbox.Group
              options={[
                {
                  label: "前に付ける（例：¥100）",
                  value: UNIT_OF_MEASURE_TYPE.frefix,
                },
                {
                  label: "後ろに付ける（例：100km）",
                  value: UNIT_OF_MEASURE_TYPE.suffix,
                },
              ]}
              defaultValue={[UNIT_OF_MEASURE_TYPE.suffix]}
            />
          </Form.Item>
        </StylesRadioItem>
      </div>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE["REQUIRED"] }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default NumberSetting;
